export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuItem.vue?vue&type=template&id=4b462754&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItem.vue?vue&type=template&id=4b462754&scoped=true&
// module id = 133
// module chunks = 0